import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import type { EsnStatus } from '../../../shared/types/atoms';

type Tone = 'info' | 'neutral' | 'faded' | 'danger' | 'warning';

const TONES: Record<EsnStatus, Tone> = {
  published: 'info',
  ready: 'info',
  active: 'info',
  draft: 'neutral',
  processing: 'neutral',
  testing: 'neutral',
  archived: 'faded',
  deactivated: 'faded',
  error: 'danger',
  invited: 'warning',
  staging: 'warning',
};

/**
 * Lifecycle chip that tells at a glance where an island version, a piece of content or an account
 * stands (Testing → Staging → Published → Archived, plus content and account states).
 * The label is projected; `status` picks the colour.
 */
@Component({
  selector: 'esn-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusBadgeComponent {
  readonly status = input.required<EsnStatus>();

  protected readonly classes = computed(() => `esn-tag esn-tag--${TONES[this.status()]}`);
}
